import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://coympvieahjboblypoft.supabase.co";
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNveW1wdmllYWhqYm9ibHlwb2Z0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgwNTA2OTIsImV4cCI6MjA3MzYyNjY5Mn0.lyotuVKMu9eEweTYArACbCUpLVyspVWYWdOAasROeDc";

// Debug logging
// console.log('Environment variables:', {
//   fromEnv: !!process.env.REACT_APP_SUPABASE_URL,
//   supabaseUrl,
//   supabaseAnonKey: supabaseAnonKey ? '***loaded***' : 'undefined'
// });

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
